// The purpose of this pack is to expose global utils from src/utils
require('expose-loader?BVServices!../src/utils/services');
require('expose-loader?BVI18n!../src/utils/services/i18n');
require('expose-loader?BVConfigs!../src/utils/configs');
require('expose-loader?BVHelpers!../src/utils/helpers');
